import { Suspense, lazy } from 'react';
import { Navigate, RouteObject } from 'react-router';

import { FeatureToggle, relativeRoutes, routes } from '@fly/shared';
import { FeatureGuard, RoleGuard } from '@fly/shared-ui';

const Account = lazy(() => import('./Account'));
const Team = lazy(() => import('./containers/Team/Team'));
const Profile = lazy(() => import('./containers/Profile/Profile'));
const TokenManagement = lazy(() => import('./containers/TokenManagement'));
const GenerateToken = lazy(() => import('./containers/GenerateToken'));
const Payment = lazy(() => import('./containers/Payment/Payment'));
const Settings = lazy(() => import('./containers/Settings/Settings'));
const PasswordAuth = lazy(
  () => import('./containers/PasswordAuth/PasswordAuth')
);
const SlackConnect = lazy(
  () => import('./containers/SlackConnect/SlackConnect')
);
const Usage = lazy(() => import('./containers/Usage/Usage'));

export const accountRoutes: RouteObject[] = [
  {
    path: `${routes.DASHBOARD.ACCOUNT.ROOT}/*`,
    element: (
      <Suspense>
        <Account />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={routes.DASHBOARD.ACCOUNT.PROFILE} replace />,
      },
      {
        path: relativeRoutes.TEAM_MANAGEMENT,
        element: (
          <Suspense>
            <Team />
          </Suspense>
        ),
      },
      {
        path: relativeRoutes.PAYMENT,
        element: (
          <FeatureGuard feature={FeatureToggle.PAYMENT}>
            <RoleGuard requireAdmin>
              <Suspense>
                <Payment />
              </Suspense>
            </RoleGuard>
          </FeatureGuard>
        ),
      },
      {
        path: relativeRoutes.PROFILE,
        element: (
          <Suspense>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: relativeRoutes.TOKEN_MANAGEMENT,
        element: (
          <Suspense>
            <TokenManagement />
          </Suspense>
        ),
      },
      {
        path: `${relativeRoutes.TOKEN_MANAGEMENT}/${relativeRoutes.GENERATE}`,
        element: (
          <Suspense>
            <GenerateToken />
          </Suspense>
        ),
      },
      {
        path: relativeRoutes.SETTINGS,
        element: (
          <FeatureGuard feature={FeatureToggle.SLACK}>
            <Suspense>
              <Settings />
            </Suspense>
          </FeatureGuard>
        ),
      },
      {
        path: relativeRoutes.PASSWORD_AUTH,
        element: (
          <Suspense>
            <PasswordAuth />
          </Suspense>
        ),
      },
      {
        path: relativeRoutes.SLACK_CONNECT,
        element: (
          <FeatureGuard feature={FeatureToggle.SLACK}>
            <Suspense>
              <SlackConnect />
            </Suspense>
          </FeatureGuard>
        ),
      },
      {
        path: relativeRoutes.USAGE,
        element: (
          <Suspense>
            <Usage />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <Navigate to={routes.DASHBOARD.ACCOUNT.PROFILE} replace />,
      },
    ],
  },
];
